/************
 * Model Class
 * File Name ...: pastrequests.components.ts
 * Generated By : ianday on 11/29/23
 * Date ........: 11/29/23
 /************/
import {ValidationResult} from './validation-result';

export interface PastRequests {
    id: number | null;
    dateCompleted: string;
    requestType: string;
    totalAmountProvided: string;
    agencyName: string;
    dateCreated: string;
    amountRequested: string;
    statusId: number;
    statusDescription: string;
    currentNeed: string;
    unitOfMeasure: string;
}

export class PastRequests {
    constructor() {
        this.id = 0;
        this.dateCompleted = '';
        this.requestType = '';
        this.totalAmountProvided = '';
        this.agencyName = '';
        this. dateCreated = '';
        this.amountRequested = '';
        this.statusId = 0;
        this.statusDescription = '';
        this.currentNeed = '';
        this.unitOfMeasure = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();


        return vr;
    }
}
